import React from 'react'
import PropTypes from 'prop-types'
import AjaxLoaderImg from './AjaxLoaderImg'

class AjaxLoader extends React.Component {
    hide () {
        this.container.style.display = 'none'
    }

    render () {
        return (
            <div className='ajax-loader' ref={el => this.container = el}>
                <div className='row'>
                    <div className='col-12 text-center py-5'>
                        <AjaxLoaderImg className={this.props.className} width={this.props.width} />
                    </div>
                </div>
            </div>
        )
    }
}

AjaxLoader.propTypes = {
    width: PropTypes.string
}

export default AjaxLoader



// WEBPACK FOOTER //
// ./resources/js/components/AjaxLoader.js